import AdminUpdatePasein from "../../components/AdminMedicalItem/AdminMedicalItemUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
